import React, { useEffect, useState, useContext } from "react";
import Axios from "axios";
import { Spin } from "antd";
import { ThemeContext } from "./ThemeContext";
import { masonryOptions } from "./exports";
import Masonry from "react-masonry-component";
import { Link } from "react-router-dom";
const GetMemes = () => {
  const [memes, setMemes] = useState([]);
  const [dark, setDark] = useContext(ThemeContext);
  const [load, setLoad] = useState(true);
  useEffect(() => {
    (async () => {
      Axios.get("https://api.imgflip.com/get_memes").then(response => {
        setMemes(response.data.data.memes);
        console.log(response.data.data);
        setLoad(false);
      });
    })();
  }, []);
  const RenderItems = () => {
    return (
      <div
        style={{
          backgroundColor: dark ? "black" : "white"
        }}>
        <h2 style={{ color: dark ? "white" : "black" }}>
          Click on Meme to edit
        </h2>
        {/* {memes.map((item, index) => (
          <img src={item.url} alt={item.name} className="image" />
        ))} */}
        <Masonry
          className={"grid"}
          elementType={"div"}
          options={masonryOptions}
          disableImagesLoaded={false}
          style={{ marginLeft: "auto", marginRight: "auto" }}
          updateOnEachImageLoad={false}>
          {memes.map((img, i) => {
            if (img.box_count == 2)
              return (
                <Link to={`/edit/${img.id}`}>
                  <div key={i}>
                    <img src={img.url} style={{ width: 300 }} />
                  </div>
                </Link>
              );
          })}
        </Masonry>
      </div>
    );
  };
  return (
    <div style={{ paddingTop: 70, backgroundColor: dark ? "black" : "white" }}>
      {load ? <Spin tip="Loading" style={{ margin: 30 }} /> : <RenderItems />}
    </div>
  );
};

export default GetMemes;
